import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromDirectOnboarding from "../reducers/direct-onboarding.reducer";

export const getDirectOnboardingConfigsState =
  createFeatureSelector<fromDirectOnboarding.DirectOnboardingConfigState>(
    fromDirectOnboarding.FEATURE_KEY,
  );

export const getDirectOnboardingConfigEntities = createSelector(
  getDirectOnboardingConfigsState,
  fromDirectOnboarding.getDirectOnboardingConfigEntities,
);

export const getDirectOnboardingConfigs = createSelector(
  getDirectOnboardingConfigEntities,
  (entities) => Object.keys(entities).map((id) => entities[id]),
);
